module.exports = __webpack_public_path__ + "img/CATEGORY ICON-17.40ef8247.png";